import { render, staticRenderFns } from "./objectStageSetAndGroupSet.vue?vue&type=template&id=5e9bcbb5"
import script from "./objectStageSetAndGroupSet.vue?vue&type=script&lang=js"
export * from "./objectStageSetAndGroupSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e9bcbb5')) {
      api.createRecord('5e9bcbb5', component.options)
    } else {
      api.reload('5e9bcbb5', component.options)
    }
    module.hot.accept("./objectStageSetAndGroupSet.vue?vue&type=template&id=5e9bcbb5", function () {
      api.rerender('5e9bcbb5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/object/object/objectStageSetAndGroupSet.vue"
export default component.exports